import React from 'react';
import SADropdown from "../../common/dropdown/SADropdown";
import {injectIntl} from "react-intl";
import Time from "../../../services/Time";

class AvailabilityEnd extends React.Component {

  render() {
    const {intl:{formatMessage}, availabilities, error, selectedDates } = this.props;
    const endDates = availabilities.map(a => a.day);
    const selectedDay = availabilities.find(a => a.day === selectedDates.endDate) || {slots:[]};
    const slots = selectedDay.slots;

    if (!endDates.includes(selectedDates.endDate)){
      endDates.push(selectedDates.endDate);
    }

    endDates.sort();
    slots.sort();

    return (
      <div className="form-field row">
        <ul className="list col-md-5 col-xxl-5 ">
          <label>{formatMessage({id: 'placeholder.endDate'})}</label>
          <SADropdown name="endDate" value={selectedDates.endDate}
                      choices={endDates.map(d=>({value:d, display:Time.dateFromApiToDisplay(d)}))} onChange={this.props.onDateChange}
                      error={error}/>
        </ul>
        <ul className="list col-md-5 col-xxl-5 ">
          <label>{formatMessage({id: 'placeholder.endTime'})}</label>
          <SADropdown name="endTime" value={selectedDates.endTime}
                      choices={slots.map(t=>({value:t, display:Time.timeFromApiToDisplay(t)}))} onChange={this.props.onTimeChange}
                      error={error}/>

        </ul>
      </div>
    )
  }
}

export default injectIntl(AvailabilityEnd);



// WEBPACK FOOTER //
// ./src/components/interventiondetail/planning/AvailabilityEnd.js